import REQUEST_FILE_UPLOAD_QUERY from '@/shared/api/queries/requestFileUpload';
import type {
  RequestFileUploadQuery,
  RequestFileUploadQueryVariables,
} from '@/shared/api/generated/graphql';
import createClient from '../client/apolloClient';

export type RequestFileUploadResult = {
  isSuccess: boolean;
  message: string;
  urls: string[];
};

/**
 * Requests pre-signed upload URLs for a number of files of one type. Runs the requestFileUpload query and returns a copy of the URL list on success, throwing the server message otherwise.
 *
 * @param type - Kind of file being uploaded.
 * @param amount - How many upload URLs are needed.
 * @returns A promise resolving to the array of upload URLs.
 */
const handleRequestFileUpload = async (type: string, amount: number) => {
  const client = await createClient();
  const requestFileUploadResult = await client.query<
    RequestFileUploadQuery,
    RequestFileUploadQueryVariables
  >({
    query: REQUEST_FILE_UPLOAD_QUERY,
    variables: {
      input: {
        type,
        amount,
      },
    },
  });
  const { data } = requestFileUploadResult;
  const { requestFileUpload } = data;
  if (requestFileUpload.isSuccess) {
    return [...requestFileUpload.urls];
  }
  throw new Error(requestFileUpload.message);
};

export default handleRequestFileUpload;
